import { get_token } from "@/router";
export default {
  name: 'AddTaskCard',
  props: {
     column_id: {
      type: Number,
      required: true
    }
    },
  data() {
    return ({
      task_name: '',
      selectedDate: '',
      members: [],
      assignedMembers: [],
      searchQuery: '',

    });
  },
    computed: {
    filteredSuggestions() {
        const query = (this.searchQuery || '').toLowerCase();
        return this.members.filter(member => {
        const name = member.full_name || member.name || '';
        const notAssigned = !this.assignedMembers.find(a => a.id === member.id);
        return name.toLowerCase().includes(query) && notAssigned;
        });
    }
    },
  mounted(){
   this.fetchPortalMembers();
  },
  methods: {
    getToken() {
            return get_token();
            },
    add_task(){
     const assigned_ids = this.assignedMembers.map(u => u.id);
     const formattedDate = this.selectedDate
      ? new Date(this.selectedDate).toISOString().split('T')[0]  // "YYYY-MM-DD"
      : null;


      $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_task/`,
                method: 'POST',
                headers: {
                'Authorization': `Token ${this.getToken()}`,
                'Content-Type': 'application/json'
                },
                data: JSON.stringify({column_id: this.column_id,name:this.task_name,assigned_ids:assigned_ids,due_date:formattedDate}),
                success: (response) => {
                var status = response.status
                if (status == "success") {
                    this.$emit("add-task", response.data);
                }

                },

                complete: () => {
                this.isLoading = false;
                }
            });
    },
    triggerDatePicker() {
        const input = this.$refs.dateInput;
        if (input.showPicker) {
            input.showPicker();
        } else {
            input.focus();
        }


    },
    handleDateChange(event) {
      this.selectedDate = event.target.value;
    },
    formatDate(date) {
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return new Date(date).toLocaleDateString(undefined, options);
    },
 fetchPortalMembers() {
    this.members = [];

    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_members/`,
      method: "GET",
      data: { portal_id:this.$route.params.portal_id },
      headers: {
        "Authorization": `Token ${this.getToken()}`,
        "Content-Type": "application/json"
      },
      success: (response) => {
        if (response.status === "success") {
          this.members = response.data.members;
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        }
      },
      error: (xhr) => {
        console.error("Error fetching portal members:", xhr);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  },
  getInitials(name) {
  if (!name || typeof name !== 'string') return '??'; // fallback
  const parts = name.trim().split(' ');
  return parts.map(p => p[0]).join('').toUpperCase().substring(0, 2);
},
   assignUser(member) {
    if (!this.assignedMembers.find(a => a.id === member.id)) {
      this.assignedMembers.push(member);
    }
  },
    removeAssignedUser(member) {
        this.assignedMembers = this.assignedMembers.filter(a => a.id !== member.id);
    },
  }
};